import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { environment } from "../../../../../environments/environment";
import { UserInfos } from "../../models/user_infos.model";
import { StatsUserInfos } from "../../models/stats-user-infos.model";
import { safeFirstValueFrom } from "../../../../shared/utils/safe-first-value-from";

@Injectable({ providedIn: "root" })
export class UiApiService implements EntityApiService<UserInfos> {
  loadOne(id: string): Observable<UserInfos> {
    return this.httpClient.get<UserInfos>(
      `${environment.api()}/user_infos/id/${id}`,
    );
  }

  async loadOneByUserId(userId: string) {
    return await safeFirstValueFrom(
      this.httpClient.get<UserInfos>(
        `${environment.api()}/user_infos/userId/${userId}`,
      ),
    );
  }

  async loadCurrent() {
    return await safeFirstValueFrom(
      this.httpClient.get<UserInfos>(`${environment.api()}/user_infos`),
    );
  }

  httpClient = inject(HttpClient);

  create(entity: UserInfos): Observable<UserInfos> {
    return this.httpClient.post<UserInfos>(
      `${environment.api()}/user_infos`,
      entity,
    );
  }

  remove(id: string): Observable<string> {
    throw new Error("Method not implemented.");
  }

  update(entity: UserInfos): Observable<UserInfos> {
    return this.httpClient.post<UserInfos>(
      `${environment.api()}/user_infos`,
      entity,
    );
  }

  loadAll(): Observable<UserInfos[]> {
    return this.httpClient.get<UserInfos[]>(
      `${environment.api()}/user_infos/all`,
    );
  }

  stats(payload: {
    userInfosId: string;
    dateDebut: Date;
    dateFin: Date;
  }): Observable<StatsUserInfos> {
    return this.httpClient.post<StatsUserInfos>(
      `${environment.api()}/stats/user-infos`,
      payload,
    );
  }
}
